import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../../assets/1.jpg'; // same hero image

const Machin = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[300px] bg-cover bg-center flex flex-col justify-center px-6"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <h1 className="text-white text-4xl md:text-5xl font-bold">Machin</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Machin
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr />
        {/* <p className="text-gray-700 text-lg mt-4">Machin page content goes here...</p> */}
      </div>
    </div>
  );
};

export default Machin;
